'use strict';
const s3SignatureValidImpl = require('./s3-signature-valid');
module.exports = function GoldFileHistoryModel(pageState, s3FileModel, optional) {
	if (!pageState || !s3FileModel) {
		throw new Error('invalid-args');
	}
	let lastHistoryByte = 0, changesHistoryPath = false;
	const self = this,
		s3SignatureValid = (optional && optional.s3SignatureValid) || s3SignatureValidImpl,
		getChangesHistoryPath = function () {
			if (s3SignatureValid(changesHistoryPath)) {
				return Promise.resolve(changesHistoryPath);
			} else {
				return s3FileModel.getHistoryFileUrl(pageState.getPathInfo())
				.then(url => {
					changesHistoryPath = url;
					return url;
				});
			}
		};
	self.getLastHistoryByte = () => lastHistoryByte;
	self.setLastHistoryByte = (b) => lastHistoryByte = b;
	self.setHistoryPath = (changesHistoryPathURL) => {
		changesHistoryPath = changesHistoryPathURL;
	};

	self.loadChangesHistory = (range) => {
		const optionalRange = (range && {range: range}) || false,
			startByte = (range && range.startByte) || 0;
		return getChangesHistoryPath()
		.then(historyFilePath => s3FileModel.loadChangesHistoryFile(historyFilePath, optionalRange))
		.then((historyResponse) => {
			const historyContent = historyResponse.data,
				sizeText = historyResponse.headers && historyResponse.headers['content-length'],
				size = (sizeText && parseInt(sizeText)) || 0;

			lastHistoryByte = startByte + size;
			if (!historyContent || !historyContent.length) {
				return [];
			}
			return historyContent.split('\n').filter((line) => !!line).map((line) => JSON.parse(line));
		})
		.catch((reason) => {
			if (reason === 'end-of-file') {
				return [];
			}
			throw reason;
		});

	};

};
